export default {
  TaxRate: {
    Title: 'Cập nhật quy định mới',
    Content:
      'Nghị quyết <b>43/2022/QH15</b> về việc giảm 2% thuế suất thuế GTGT <b>đã hết hiệu lực từ ngày 31/12/2022.</b> Vui lòng cập nhật lại thuế suất theo quy định.',
  },
};
